// Search //
document.addEventListener("DOMContentLoaded", function(event) {
    let siteHeaderSearchInput = document.querySelector("#headerSearchText")
    let searchPageInput = document.querySelector(".search-page-input")

    function siteSearch(isSearchPage) {
        if(isSearchPage) {
            window.location.href = "/site-search?searchText=" + searchPageInput.value;
        } else {
            window.location.href = "/site-search?searchText=" + siteHeaderSearchInput.value;
        }
    }

    if (searchPageInput) {
        searchPageInput.onkeyup = function(event) {
            if (event.keyCode == 13 || event.keyCode == "Enter") {
                siteSearch(true)
            }
        }
    }

    if (siteHeaderSearchInput) {
        siteHeaderSearchInput.onkeyup = function(event) {
            if (event.keyCode == 13 || event.keyCode == "Enter") {
                siteSearch(false)
            }
        }
    }
});